export function rootRouteErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }

  if (typeof error === "string" && error.trim().length > 0) {
    return error;
  }

  return "An unexpected router error occurred.";
}

export function rootRouteErrorDetails(error: unknown): string {
  if (error instanceof Error) {
    return error.stack ?? error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  try {
    return JSON.stringify(error, null, 2) ?? "No additional error details are available.";
  } catch {
    return "No additional error details are available.";
  }
}

export type KeybindingsConfigToastModel =
  | {
      readonly kind: "ignore";
      readonly nextSeenId: number;
    }
  | {
      readonly kind: "success";
      readonly nextSeenId: number;
      readonly title: "Keybindings updated";
      readonly description: "Keybindings configuration reloaded successfully.";
    }
  | {
      readonly kind: "warning";
      readonly nextSeenId: number;
      readonly title: "Invalid keybindings configuration";
      readonly description: string;
    };

export interface KeybindingsConfigNotificationInput {
  readonly id: number;
  readonly source: string;
  readonly payload: {
    readonly issues: ReadonlyArray<{
      readonly kind: string;
      readonly message: string;
    }>;
  };
}

export function resolveKeybindingsConfigToastModel(input: {
  readonly notification: KeybindingsConfigNotificationInput | null;
  readonly seenNotificationId: number;
}): KeybindingsConfigToastModel {
  const { notification, seenNotificationId } = input;
  if (!notification || notification.id <= seenNotificationId) {
    return { kind: "ignore", nextSeenId: seenNotificationId };
  }
  if (notification.source !== "keybindingsUpdated") {
    return { kind: "ignore", nextSeenId: notification.id };
  }

  const issue = notification.payload.issues.find((entry) => entry.kind.startsWith("keybindings."));
  if (!issue) {
    return {
      kind: "success",
      nextSeenId: notification.id,
      title: "Keybindings updated",
      description: "Keybindings configuration reloaded successfully.",
    };
  }

  return {
    kind: "warning",
    nextSeenId: notification.id,
    title: "Invalid keybindings configuration",
    description: issue.message,
  };
}
